import React from 'react';
import HowItWorks from "./HowItWorks/HowItWorks";
import Banner from "./Banner/Banner";
import Consoles from "./Consoles/Consoles";
import Features from "./Features/Features";
import ComparisonTable from "./ComparisonTable/ComparisonTable";
import EnjoyGames from "./EnjoyGames/EnjoyGames";
import Footer from "../Footer/Footer";
import Map from "./Map/Map";
import Characteristics from "./Сharacteristics/Characteristics";
import FAQ from "./FAQ/FAQ";
import GamesCatalog from "./GamesCatalog/GamesCatalog";


const AppContent = ({openModal, selectConsole}) => {
    return (
        <>
            <div className="AppContent">
                <Banner openModal={openModal}/>
                <HowItWorks/>
                <Consoles selectConsole={selectConsole}  />
                <GamesCatalog />
                <Features openModal={openModal}/>
                <Characteristics openModal={openModal}/>
                <ComparisonTable  openModal={openModal}/>
            </div>
            <Map/>
            <FAQ/>
            <EnjoyGames openModal={openModal} />
            <Footer />
        </>
    );
};

export default AppContent;